// extracted by mini-css-extract-plugin
module.exports = {"steps":"_5a94992","tear":"_a829b41","inner":"_6b9abd0","step":"_998bf98","left":"_af67f50","right":"_0ec1b27","title":"_6ae640e","text":"_8b4b04f"};